import FieldContainer from 'refactored/features/soForm/steps/card/creditCard/Form/components/FieldContainer/component';

export default FieldContainer;
